import { JAIN } from "../../utils/constant";
import { capitalize, getBrideGroomNameFromURL } from "../../utils/string";

const firstName = (name) => (name ? capitalize(name.trim().split(" ")[0]) : "");

/**
 * Display names, matching the other themes: taken from the invitation URL,
 * falling back to the first names in the invite data.
 */
export const coupleNames = (bride, groom) => {
  const fromUrl = getBrideGroomNameFromURL();
  return {
    first: fromUrl.brideName || firstName(bride?.name),
    second: fromUrl.groomName || firstName(groom?.name),
  };
};

export const isJainInvite = (religion) => religion === JAIN;
